<div class="website-chat-banner">
  <button class="dismiss-btn" (click)="dismiss()" type="button">
    <ng-icon name="heroXMark"></ng-icon>
  </button>

  <div class="banner-illustration" aria-hidden="true">
    <div class="widget-mock">
      <div class="mock-header">
        <span class="mock-avatar">
          <img src="assets/images/website-chat-banner-avatar.png" alt="" />
          <span class="online-dot"></span>
        </span>
        <span class="mock-name">North Shore Painting</span>
        <svg class="mock-close" viewBox="0 0 16 16" fill="currentColor">
          <path d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
        </svg>
      </div>
      <p class="mock-date">Friday, March 23</p>
      <div class="mock-greeting">
        <span class="mock-greeting-avatar">
          <img src="assets/images/website-chat-banner-avatar.png" alt="" />
        </span>
        <p class="mock-bubble">Welcome to North Shore Painting. Click the button below to get started.</p>
      </div>
    </div>
  </div>

  <div class="banner-bottom">
    <p class="eyebrow">{{ 'WEBSITE_CHAT_BANNER.LABEL' | translate }}</p>
    <p class="title-text">{{ 'WEBSITE_CHAT_BANNER.TITLE' | translate }}</p>
  </div>

  <button class="cta-btn" (click)="navigate()" type="button" [attr.aria-label]="'WEBSITE_CHAT_BANNER.LABEL' | translate">
    <ng-icon name="heroArrowRightMini"></ng-icon>
  </button>
</div>
